export default __webpack_public_path__ + "static/realestate-e6311f8aacf911224a38249362e6f760.webp";